function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.905 0.0950656C12.7783 -0.0316885 12.5722 -0.0316885 12.4455 0.0950656L6.50005 6.04081L0.555277 0.0950656C0.42853 -0.0316885 0.222458 -0.0316885 0.0957105 0.0950656C-0.0310368 0.22182 -0.0310368 0.427902 0.0957105 0.554657L6.04049 6.5004L0.0950605 12.4455C-0.0316868 12.5722 -0.0316868 12.7783 0.0950605 12.9051C0.158738 12.9688 0.24197 13 0.325143 13C0.408315 13 0.491552 12.9682 0.555225 12.9051L6.5 6.95999L12.4448 12.9051C12.5085 12.9688 12.5917 13 12.6749 13C12.758 13 12.8413 12.9682 12.9049 12.9051C13.0317 12.7783 13.0317 12.5722 12.9049 12.4455L6.95951 6.5004L12.9049 0.555307C13.0317 0.428552 13.0317 0.22247 12.9049 0.0957156L12.905 0.0950656Z",
  fill: "white"
});

function SvgPencilBannerClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pencil banner close button icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilBannerClose);
export default __webpack_public_path__ + "static/media/pencil-banner-close.5d805ea7.svg";
export { ForwardRef as ReactComponent };